function toHex(bytes: ArrayBuffer): string {
  return Array.from(new Uint8Array(bytes))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export async function hashUserId(userId: string): Promise<string> {
  const normalized = userId.trim().toLowerCase();
  if (!normalized) {
    throw new Error('Cannot hash an empty user id');
  }
  const encoder = new TextEncoder();
  const digest = await crypto.subtle.digest('SHA-256', encoder.encode(normalized));
  return toHex(digest);
}
